var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaIcDatepickerRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00032 1H6.00032V2.16675H11.0003V1H13.0003V2.16675H14.667H15.167V2.66675V14.6667V15.1667H14.667H2.66699H2.16699V14.6667V2.66675V2.16675H2.66699H4.00032V1ZM3.16699 14.1667V6H14.167V14.1667H3.16699ZM8.41138 11.4002L11.9669 8.73356L11.3669 7.93356L8.15829 10.34L6.68715 8.86889L5.98005 9.576L7.75782 11.3538L8.06446 11.6604L8.41138 11.4002Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaIcDatepickerRange);
export default __webpack_public_path__ + "static/media/pa_ic_datepicker_range.9ccd57a007ebc10b7271741b0d239bec.svg";
export { ForwardRef as ReactComponent };